// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_StoreResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for store() — POST /caixa/abrir
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_StoreResponseDados {
id?: number
franquia_id?: number
operador_id?: number
operador_nome?: string
data_hora_abertura?: string
saldo_inicial?: number
status?: string
observacao?: string
created_at?: string
updated_at?: string
}

export type Caixa_StoreResponse = ApiResponse<Caixa_StoreResponseDados>;

registerResponseContract('Caixa_StoreResponse', {
  id:                 { type: 'number',  required: false },
  franquia_id:        { type: 'number',  required: false },
  operador_id:        { type: 'number',  required: false },
  operador_nome:      { type: 'string',  required: false },
  data_hora_abertura: { type: 'string',  required: false },
  saldo_inicial:      { type: 'number',  required: false },
  status:             { type: 'string',  required: false },
  observacao:         { type: 'string',  required: false },
  created_at:         { type: 'string',  required: false },
  updated_at:         { type: 'string',  required: false },
})
